import { Item } from 'react-photoswipe-gallery';
import styled from 'styled-components';
import VideoPlayer from 'components/video/VideoPlayer';
import VideoPlaylistPlayer from 'components/video/VideoPlaylistPlayer';
import AspectRatioContainer from 'components/generic/AspectRatioContainer/AspectRatioContainer';
import dynamic from 'helpers/dynamic';
import Image from 'components/generic/Image';
import type { HighlightedVideoMediaItem } from '../../shared/types';
import { PreviewItem } from 'components/GalleryMediaPreviewer/shared/styles';

const StyledPreviewItem = styled(PreviewItem)`
    position: relative;
    cursor: pointer;
`;

const StyledImg = styled(Image.WithScaling)`
    width: 100%;
    height: 100%;
    object-fit: contain;
`;

const PlayIcon = styled(dynamic(() => import('icons/Play.svg?react'), { ssr: false }))`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
`;

const StyledAspectRatioContainer = styled(AspectRatioContainer)`
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
`;

export default function PreviewGalleryHighlightedVideoItem({
    highlightedVideoItem: { video, original, alt },
    ...restProps
}: {
    highlightedVideoItem: HighlightedVideoMediaItem;
}) {
    const hasAutoPlayVideos = video.autoplayVideos?.length;

    return (
        <Item
            content={
                <StyledAspectRatioContainer maxWidth="800px" ratioHeight={16} ratioWidth={9}>
                    {hasAutoPlayVideos ? <VideoPlaylistPlayer video={video} /> : <VideoPlayer video={video} />}
                </StyledAspectRatioContainer>
            }
            {...restProps}
        >
            {({ ref, open }) => (
                <StyledPreviewItem ref={ref} onClick={open}>
                    <StyledImg
                        sizes={365}
                        src={original}
                        transformType="WidthScale"
                        imageType="product"
                        alt={alt || ''}
                        loading="lazy"
                    />
                    <PlayIcon width={48} height={48} />
                </StyledPreviewItem>
            )}
        </Item>
    );
}
